const sample = [
  {
    id: 1,
    title: 'Ahsan Manzil (Pink Palace)',
    desc: 'A beautifully restored Mughal-style palace museum by the Buriganga River.',
    duration: '1–2 hours',
    price: 'Free',
    rating: 4.6,
    img: 'https://upload.wikimedia.org/wikipedia/commons/1/16/Ahsan_Manzil-Front_View.jpg'
  },
  {
    id: 2,
    title: 'Lalbagh Fort',
    desc: 'A historic 17th-century Mughal fortress featuring gardens and gateways.',
    duration: '1-3 hours',
    price: '৳ 20',
    rating: 4.5,
    img: 'https://images.pexels.com/photos/17830385/pexels-photo-17830385.jpeg'
  },
  {
    id: 3,
    title: 'Shilpakala Academy',
    desc: 'A vibrant cultural center hosting theatre, dance and art exhibitions.',
    duration: '2 hours',
    price: '৳ 300',
    rating: 4.7,
    img: 'https://upload.wikimedia.org/wikipedia/commons/b/b5/Dhaka_Art_Summit_2023.jpg'
  },
  {
    id: 4,
    title: 'Prana Yoga Studio',
    desc: 'Boutique yoga studio offering Vinyasa flow classes and workshops.',
    duration: '1 hours',
    price: '৳ 1200',
    rating: 4.7,
    img: 'https://images.pexels.com/photos/1051838/pexels-photo-1051838.jpeg'
  },
  {
    id: 5,
    title: 'Cooking Class',
    desc: 'Hands-on Bengali cooking class teaching biryani, bhorta and sweets.',
    duration: '3 hours',
    price: '৳ 1200',
    rating: 4.6,
    img: 'https://images.pexels.com/photos/2284166/pexels-photo-2284166.jpeg'
  },
  {
    id: 6,
    title: 'Purbachal Cycling Trail',
    desc: 'A scenic lakeside cycling route with smooth paths and fresh air.',
    duration: '1 hours',
    price: 'Free',
    rating: 4.5,
    img: 'https://images.pexels.com/photos/35100311/pexels-photo-35100311.jpeg'
  }
];

export default sample;
